export type HiScoreEntry = {
  name: String;
  score: number;
  timestamp: number;
  isNew?: boolean;
};

const limit = (list: HiScoreEntry[], size: number) => list.slice(0, size);

const sortByScore = (list: HiScoreEntry[]) => list.sort((a, b) => a.score > b.score ? -1 : 1);

const hiScores: HiScoreEntry[] = [
  {
    name: "oscar",
    score: 100,
    timestamp: 1,
  },
  {
    name: "oscar",
    score: 100,
    timestamp: 1,
  },
  {
    name: "oscar",
    score: 400,
    timestamp: 1,
  },
  {
    name: "oscar",
    score: 200,
    timestamp: 1,
  },
  {
    name: "oscar",
    score: 500,
    timestamp: 1,
  },
  {
    name: "oscar",
    score: 1000,
    timestamp: 1,
  },
];


const STORAGE_KEY = 'pacman-highscore';

export const createHiScoreEntry = (name: String, score: number): HiScoreEntry => ({
  name,
  score,
  timestamp: Date.now(),
});

export const readScores = (): HiScoreEntry[] => {
  const scores = localStorage.getItem(STORAGE_KEY);

  if (!scores) {
    writeScores(hiScores);
    return hiScores;
  }

  return scores ? JSON.parse(scores) : [];
};

export const writeScores = (scores: HiScoreEntry[]) => localStorage.setItem(STORAGE_KEY, JSON.stringify(scores));
export const getScores = (scores = readScores()) => limit(sortByScore(scores), 5);
